import { AxiosRequestConfig, CancelTokenSource } from 'axios';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

export function completeConfigWithCancellationTokenSource(
  config: AxiosRequestConfig,
  cancellationTokenSource: CancelTokenSource
): AxiosRequestConfig {
  return { ...config, cancelToken: cancellationTokenSource.token };
}

export function validateUrl(url: string) {
  if (isEmpty(url) || !isString(url))
    throw new Error(`Request URL can't be empty`);
}

/**
 * Replaces each instance of urlParameters with it's corresponding url
 * placeholder.
 *
 * @param {string} url The URL schema with placeholders
 * @param {Record<string, any>} urlParameters An object containing the parameters
 *          corresponding to the url placeholders
 *
 * @return {string} The resulting url with placeholders replaced with the
 *          correct value
 */
export function replaceUrlPlaceholders(
  url: string,
  urlParameters: Record<string, any>
): string {
  if (urlParameters == null) return url;

  const urlParamKeys = Object.keys(urlParameters);
  let finalUrl = url;

  urlParamKeys.forEach((key) => {
    const urlPlaceholder = `:${key}`;
    finalUrl = finalUrl.replace(urlPlaceholder, urlParameters[key]);
  });

  return finalUrl;
}
export function isSuccessResponse(status: number) {
  if (status == null) return null;

  return status >= 200 && status < 300;
}

export function isErrorResponse(status: number) {
  if (status == null) return null;

  return status >= 400 && status < 600;
}
